import instance from "./axios.base";

const getMigrationInfo = async (id) => {
  const res = await instance.get(`/empmigrations/${id}`);
  return res.data;
};

export { getMigrationInfo };
